import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, EffectFade, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';

const CarImageSlider = ({ car }) => {
  const allImages = [];
  if (car.image) {
    allImages.push(`${window.CARLOCA_UPLOADS}/cars/${car.image}`);
  }
  if (car.gallery && car.gallery.length > 0) {
    const mainFilename = car.image ? car.image.split('/').pop() : "";
    car.gallery.forEach(g => {
      const galleryFilename = g.image ? g.image.split('/').pop() : "";
      if (mainFilename !== galleryFilename) {
        allImages.push(`${window.CARLOCA_UPLOADS}/cars-gallery/${g.image}`);
      }
    });
  }
  if (allImages.length === 0) {
    allImages.push("/img/noimg.jpeg");
  }

  return (
    <div 
      className="w-100 h-100" 
      style={{ position: 'relative', overflow: 'hidden' }}
      onClick={(e) => {
        if (e.target.closest('.swiper-button-next, .swiper-button-prev, .swiper-pagination-bullet')) {
          e.stopPropagation();
          e.preventDefault();
        }
      }}
    >
      <style>{`
        .car-image-swiper .swiper-button-next,
        .car-image-swiper .swiper-button-prev {
          width: 26px;
          height: 26px;
          background-color: rgba(0, 0, 0, 0.6) !important;
          border: 1px solid rgba(255, 255, 255, 0.25) !important;
          border-radius: 50% !important;
          color: #ffffff !important;
          opacity: 0;
          transition: all 0.25s ease !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
          z-index: 10 !important;
        }
        
        .car-image-swiper .swiper-button-next::after,
        .car-image-swiper .swiper-button-prev::after {
          font-size: 9px !important;
          font-weight: 800 !important;
        }

        .car-image-swiper .swiper-button-prev {
          left: 8px !important;
        }

        .car-image-swiper .swiper-button-next {
          right: 8px !important;
        }

        .car-image-swiper:hover .swiper-button-next,
        .car-image-swiper:hover .swiper-button-prev {
          opacity: 1;
        }

        .car-image-swiper .swiper-button-next:hover,
        .car-image-swiper .swiper-button-prev:hover {
          background-color: #00889c !important;
          transform: scale(1.05);
        }
      `}</style>

      <Swiper
        modules={[Pagination, EffectFade, Navigation]}
        pagination={{ dynamicBullets: true, clickable: true }}
        navigation={allImages.length > 1}
        effect="fade"
        loop={true}
        className="w-100 h-100 car-image-swiper"
        style={{
          "--swiper-pagination-color": "#fff",
          "--swiper-pagination-bullet-inactive-color": "#fff",
          "--swiper-pagination-bullet-inactive-opacity": "0.5",
          "--swiper-pagination-bullet-size": "6px",
          "--swiper-pagination-bottom": "8px"
        }}
      >
        {allImages.map((imgSrc, index) => (
          <SwiperSlide key={index} className="w-100 h-100">
            {/* Premium cover image to prevent stretching and distortion */}
            <img src={imgSrc} alt={`${car.make} ${car.model}`} loading="lazy"
              style={{ width: "100%", height: "100%", objectFit: "cover", transition: "transform 0.3s ease", display: "block" }}
              onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.04)")} onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")} />
          </SwiperSlide>
        ))}
      </Swiper>
      {/* Gallery Count Badge */}
      {car.gallery && car.gallery.length > 0 && (
        <div style={{ position: "absolute", bottom: "8px", right: "8px", background: "rgba(0, 0, 0, 0.75)", color: "#fff", padding: "4px 10px", borderRadius: "12px", fontSize: "11px", fontWeight: "600", zIndex: 4, backdropFilter: "blur(4px)" }}>
          <i className="fa-solid fa-camera me-1"></i>
          {car.gallery.length} Photos
        </div>
      )}
    </div>
  );
};

export default CarImageSlider;
